import { render, staticRenderFns } from "./IllustrationHeading.vue?vue&type=template&id=5bc4e8ba&scoped=true"
import script from "./IllustrationHeading.vue?vue&type=script&lang=js"
export * from "./IllustrationHeading.vue?vue&type=script&lang=js"
import style0 from "./IllustrationHeading.vue?vue&type=style&index=0&id=5bc4e8ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bc4e8ba",
  null
  
)

export default component.exports